import { render, staticRenderFns } from "./VendorPaydays.vue?vue&type=template&id=3a2be96c"
import script from "./VendorPaydays.vue?vue&type=script&lang=js"
export * from "./VendorPaydays.vue?vue&type=script&lang=js"
import style0 from "./VendorPaydays.vue?vue&type=style&index=0&id=3a2be96c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports